// @mui material components
import Box, { BoxProps } from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { ThemeInterface } from "../../assets/types/ThemeInterface";

interface StyledDropZoneProps extends BoxProps {
	theme?: ThemeInterface;
	action?: string;
}

export default styled(Box)<StyledDropZoneProps>(({ theme }) => {
	const { palette, typography, borders, functions } = theme;

	const { text, white, dark, inputColors, transparent } = palette;
	const { size } = typography;
	const { borderRadius, borderWidth } = borders;
	const { rgba } = functions;

	return {
		display: "flex",
		alignItems: "center",
		justifyContent: "center", // To center the icon and text
		flexDirection: "column", // To stack the icon and text vertically
		padding: "20px",
		border: `${borderWidth[1]} dashed ${inputColors.borderColor.main} !important`, // Change to dashed
		borderRadius: borderRadius.md,
		backgroundColor: transparent.main,
		textAlign: "center", // Ensure text is centered

		"& .dz-default": {
			margin: "0 auto !important",
		},

		"& .dz-default .dz-button": {
			color: `${text.main} !important`,
			fontSize: `${size.md} !important`, // Make text larger
			fontWeight: "500",
		},

		"& .dz-preview.dz-image-preview": {
			background: transparent.main,
		},

		"& .dz-preview .dz-details": {
			color: `${dark.main} !important`,
			opacity: "1 !important",

			"& .dz-size span, & .dz-filename span": {
				backgroundColor: `${rgba(white.main, 0.7)} !important`,
			},
		},

		"& .dz-error-message": {
			display: "none !important",
		},

		"& .dz-remove": {
			color: `${dark.main} !important`,
			textDecoration: "none",

			"&:hover, &:focus": {
				textDecoration: "none !important",
			},
		},

		// Custom styling for additional text
		"& .max-size-text": {
			marginTop: "10px",
			fontSize: `${size.sm} !important`,
			color: `${text.main}`,
		},
	};
});
